import React, { Component } from 'react'
import { Route } from 'react-router-dom'
import {
    authedUserConnect,
    withRouter,
} from '../../validator'
import store from '../../admin/store'
import logout from '../../admin/actions/logout'
import { getUrlParameter } from '../../admin/actions'

@withRouter()
@authedUserConnect()
export class LogoutRoute extends Component {
    state = {
        isMounted: false,
    }

    /**
     * Gets called after component mounting
     */
    componentDidMount() {
        let {
            authedUser,
            path,
        } = this.props

        const token = getUrlParameter('token')

        if (token) {
            sessionStorage.setItem('emailUpdateToken', token)
            path = `${path}?token=${token}`
        }

        if (authedUser) {
            store.dispatch({
                type: 'SET_LOGOUT_REDIRECT',
                page: path,
            })

            logout()
        }

        this.setState({ isMounted: true })
    }

    /**
     * Render logout route
     * @return {*}
     */
    render() {
        if (!this.state.isMounted) {
            return null
        }

        return <Route {...this.props} />
    }
}
